import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { ConfirmDialog, ConfirmOptions } from '../components/dialogs/confirm-dialog/confirm-dialog.component';


@Injectable()
export class DialogService {
  constructor(
    private readonly dialog: MatDialog
    ) { }

  confirm(options: ConfirmOptions): Observable<boolean> {
    const dialogRef: MatDialogRef<ConfirmDialog, any> = this.dialog.open(ConfirmDialog, {
      width: '400px',
      data: options
    });

    return dialogRef.afterClosed()
      .pipe(
        map(result => {
          return result === 'true';
        })
      );
  }
}
